/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Latest allowed UTC end time for slots of this event kind (e.g., 18:00)
 */
export type EventKindAllowedTimeEnd = string | null;
